import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {searchTypeahead} from 'lib/search';
import SearchIcon from './SearchIcon';
import styles from './input.module.scss';

class Input extends Component {
  state = {
    typeaheadResults: [],
    query: '',
  };

  onChange = e => {
    const {children} = this.props;
    if (!children) {
      return;
    }
    const {
      target: {value: query},
    } = e;
    searchTypeahead(query).then(typeaheadResults =>
      this.setState({typeaheadResults, query})
    );
  };

  render() {
    const {defaultValue, size, placeholder, children} = this.props;
    const {typeaheadResults, query} = this.state;

    return (
      <form
        action="/search"
        className={`${styles.Input} ${styles[`Input--${size}`]}`}
        method="GET"
        role="search"
      >
        <label className={styles.Input__field}>
          <SearchIcon className={styles.Input__icon} />
          <input
            aria-label="Search help articles"
            autoComplete="off"
            className={styles.Input__control}
            defaultValue={defaultValue}
            name="query"
            onChange={this.onChange}
            placeholder={placeholder}
            type="search"
          />
        </label>
        {children && children({query, typeaheadResults})}
      </form>
    );
  }
}

Input.propTypes = {
  children: PropTypes.func,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
};

Input.defaultProps = {
  placeholder: 'Search articles',
  size: 'large',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/search/Input.js